import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class InputsService {
  constructor(private http: HttpClient, private tokenStorageService: TokenStorageService) { }
  async getInputs(obj) {
    let body = {
      target: "getInputs",
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getProductcollRegex(obj) {
    let body = {
      target: "getInputsRegex",
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {

        resolve(result)
      }, reject);
    })
  }
  async getInputsCount(obj) {
    let body = {
      target: "getInputsCount",
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async saveSingleInput(Product) {
    let body = {
      target: "saveInputOne",
      source: Product,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }

  async savemultipleProducts(obj) {
    let body = {
      target: "saveInputsMany",
      source: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async updateproductData(editedproduct) {
    let obj = {
      productId: editedproduct.productId,
      group: editedproduct.group
    }
    let body = {
      target: "updateInputs",
      source: editedproduct,
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }

}